export default class ListTempFileJs {
  showModalEditSavedProjectName() {
    $('#modalEditSavedProjectName').modal('show')
    $('#assignAkairePopup').modal('hide')
  }

  showModalEditSavedTaskName() {
    $('#modalEditSavedTaskName').modal('show')
    $('#assignAkairePopup').modal('hide')
  }

  updateSavedTaskName() {
    const modal = $('#modalEditSavedTaskName');
    const taskName = modal.find('#taskEditName').val()
    const taskId = modal.find('#edit-saved-task-id').val()
    const projectId = $('#modalEditSavedProjectName').find('#edit-saved-project-id').val()

    Shared.callAjax(
      Routes.owner_project_task_update_task_name_path(projectId, taskId),
      {name: taskName},
    ).done((data) => {
      modal.modal('hide')
      $('#assignAkairePopup').find('.display-from-task-name').text(taskName)
      $('.div-button-assign-file [data-from-task-id="' + taskId + '"]').attr('data-from-task-name', taskName)
      $('#assignAkairePopup').modal('show')
    }).fail((data) => {
      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  updateSavedProjectName() {
    const modal = $('#modalEditSavedProjectName');
    const projectName = modal.find('#projectEditName').val()
    const projectId = modal.find('#edit-saved-project-id').val()

    Shared.callAjax(
      Routes.update_project_name_owner_project_path(projectId),
      {project_name: projectName},
      '',
      'put'
    ).done((data) => {
      modal.modal('hide')
      $('#assignAkairePopup').find('.display-from-project-name').text(projectName)
      $('.div-button-assign-file [data-from-project-id="' + projectId + '"]').attr('data-from-project-name', projectName)
      $('#assignAkairePopup').modal('show')
    }).fail((data) => {
      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  showModalSelectSavedProject() {
    const savedprojectId = $('#assignAkairePopup').find('#saved-project-id').val()
    const url = Routes.fetch_list_project_akaire_feature_akaires_path();
    Shared.callAjax(url, {saved_project_id: savedprojectId}, 'script', 'get').done(() => {
      $('#selectSavedProjectModal').modal('show')
      $('#assignAkairePopup').modal('hide')
    })
  }

  showModalSelectSavedTask() {
    const isShowTask = $('#assignAkairePopup').find('#is-show-task').val()
    const savedprojectId = $('#assignAkairePopup').find('#saved-project-id').val()
    const notShowPopup = $('#not_show_popup').val()
    if (isShowTask == 'true') {
      this.showListTask(savedprojectId)
    } else {
      const isProjectOwner = $('#assignAkairePopup').find('#is-project-owner').val()
      if(isProjectOwner == 'true') {
        $("#modalShowTask").find('#project_id').val(savedprojectId)
        if(notShowPopup == 'true') {
          $("#modalShowTask").find('.btn-submit-setting-task-for-project').click();
          this.showListTask(savedprojectId)
        } else {
          $("#modalShowTask").find('#checkbox-show-popup-again').prop('checked', false);
          $("#modalShowTask").modal("show")
        }
      } else {
        $('#modalTaskIsHidden').modal('show')
      }
    }
  }

  showListTask(savedprojectId) {
    const savedTaskId = $('#assignAkairePopup').find('#saved-task-id').val()
    const url = Routes.fetch_list_task_akaire_feature_akaires_path({saved_project_id: savedprojectId, saved_task_id: savedTaskId});
    Shared.callAjax(url, {saved_task_id: savedTaskId}, 'script', 'get').done(() => {
      $('#selectSavedTaskModal').modal('show')
      $('#assignAkairePopup').modal('hide')
    })
  }

  searchProjectByName(searchInput) {
    clearTimeout(this.searchTimeout)
    const keyword = $(searchInput).val().trim()
    const savedprojectId = $('#modalEditSavedProjectName').find('#edit-saved-project-id').val() || $('#assignAkairePopup').find('#saved-project-id').val() || ''
    const url = Routes.fetch_list_project_akaire_feature_akaires_path({saved_project_id: savedprojectId})
    const searchParams = keyword ? {q: {name_cont: keyword}} : {}

    this.searchTimeout = setTimeout(() => {
      Shared.callAjax(url, searchParams, 'script', 'get').done(() => {})
    }, 300)
  }

  searchTaskByName(searchInput) {
    clearTimeout(this.searchTimeout)
    const keyword = $(searchInput).val().trim()
    const savedprojectId = $('#assignAkairePopup').find('#saved-project-id').val() || ''
    const url = Routes.fetch_list_task_akaire_feature_akaires_path({saved_project_id: savedprojectId})
    const searchParams = keyword ? {q: {name_cont: keyword}} : {}
    this.searchTimeout = setTimeout(() => {
      Shared.callAjax(url, searchParams, 'script', 'get').done(() => {})
    }, 300)
  }

  changeSavedProject(element, isCurrentProject = 'false') {
    const animationId = $('#assignAkairePopup').find('#animation_id').val()
    const projectId = $(element).data('project-id')
    if (!animationId) {
      Popup.alert('ファイルが選択されていません。')
      return
    }

    if (isCurrentProject == 'true') {
      $('#assignAkairePopup').modal('show')
      $('#selectSavedProjectModal').modal('hide')
      return
    }

    $('#assignAkairePopup').find('.number-user-invite-wrapper').addClass('d-none');
    $('#assignAkairePopup').find('.number-user-invite-wrapper-dashed').addClass('d-none');

    Shared.callAjax(
      Routes.change_saved_project_akaire_feature_akaires_path(),
      {saved_project_id: projectId, animation_id: animationId},
      'script',
      'post'
    ).done(() => {
      $('#selectSavedProjectModal').modal('hide')
      $('#assignAkairePopup').modal('show')
    })
  }

  changeSavedTask(element, isCurrentTask = 'false', isRemoveTask = 'false') {
    const animationId = $('#assignAkairePopup').find('#animation_id').val()
    const savedProjectId = $('#assignAkairePopup').find('#saved-project-id').val()
    let taskId = null
    if (isRemoveTask == 'false') {
      taskId = $(element).data('task-id')
    }

    if (isCurrentTask == 'true') {
      $('#assignAkairePopup').modal('show')
      $('#selectSavedTaskModal').modal('hide')
      return
    }

    Shared.callAjax(
      Routes.change_saved_task_akaire_feature_akaires_path(),
      {saved_task_id: taskId, saved_project_id: savedProjectId, animation_id: animationId},
      'script',
      'post'
    ).done(() => {
      $('#assignAkairePopup').modal('show')
      $('#selectSavedTaskModal').modal('hide')
      $('#assignAkairePopup').find('.display-from-task-name').text($(element).data('task-name'))
      $('#assignAkairePopup').find('#saved-task-id').val(taskId)
      $('#assignAkairePopup').find('.button-assign-member-wrapper').removeClass('d-none');
      $('#assignAkairePopup').find('.btn-submit-assign-akaire').addClass('d-none');
    })
    .fail((data) => {
      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  goToPage(page) {
    const keyword = $('#selectSavedProjectModal').find('#searchProjectInput').val().trim()
    const savedprojectId = $('#modalEditSavedProjectName').find('#edit-saved-project-id').val() || $('#assignAkairePopup').find('#saved-project-id').val() || ''
    const url = Routes.fetch_list_project_akaire_feature_akaires_path({saved_project_id: savedprojectId})
    const params = {page: page}
    if (keyword) {
      params.q = {name_cont: keyword}
    }

    Shared.callAjax(url, params, 'script', 'get').done(() => {
    })
  }

  goToTaskPage(page) {
    const keyword = $('#selectSavedTaskModal').find('#searchTaskInput').val().trim()
    const savedprojectId = $('#assignAkairePopup').find('#saved-project-id').val() || ''
    const url = Routes.fetch_list_task_akaire_feature_akaires_path({saved_project_id: savedprojectId})
    const params = {page: page}
    if (keyword) {
      params.q = {name_cont: keyword}
    }

    Shared.callAjax(url, params, 'script', 'get')
  }

  showModalEditFileName() {
    const animationId = $('#assignAkairePopup').find('#animation_id').val()
    const fileName = $('#assignAkairePopup').find('.display-file-name')[0].textContent.trim()
    $('#modalEditFileName').find('#animation-id').val(animationId)
    $('#modalEditFileName').find('#projectFileName').val(fileName)
    $('#modalEditFileName').modal('show')
    $('#assignAkairePopup').modal('hide')
  }

  updateFileName() {
    const animationId = $('#modalEditFileName').find('#animation-id').val()
    const fileName = $('#modalEditFileName').find('#projectFileName').val()
    $('#modalEditFileName').modal('hide')
    $('#assignAkairePopup').modal('show')
    $('#assignAkairePopup').find('.display-file-name').text(fileName)
    $('#assignAkairePopup').find('#file-name').val(fileName)
    $('.file-name-will-create').text(fileName)
  }

  showModalSettingMember(event) {
    $('#assignAkairePopup').modal('hide')
    $('#popupInviteMember').removeClass('d-none')
    $('#personInChargeOfObject').removeClass('d-none')
    Shared.showModalForElementNotClose($("#personInChargeOfObject"))
    event.stopPropagation()
  }

  submitSettingMemberProject() {
    const countUserInvite = $('#popupInviteMember').find('.check-box-check-member:checked').length;
    const countUserInviteNew = $('#popupInviteMember').find('.tr-new-email').length;
    $('#popupInviteMember').addClass('d-none')
    $('#assignAkairePopup').modal('show')
    $('#assignAkairePopup').find('.number-user-invite-wrapper').removeClass('d-none');
    $('#assignAkairePopup').find('.number-user-invite-wrapper-dashed').removeClass('d-none');
    $('#assignAkairePopup').find('.number-user-invite').text(`${countUserInvite + countUserInviteNew - 1}名`);
    $('.btn-submit-assign-akaire').removeClass('d-none');
    $('.button-assign-member-wrapper').addClass('d-none');
  }

  submitSettingMemberTask() {
    const countUserInvite = $('#personInChargeOfObject').find('.pick-pics:checked').length;
    const countUserInviteNew = $('#personInChargeOfObject').find('.tr-new-email').length;


    let user_invite_ids = [];
    const user_delete_ids = $('#list-user-uncheck').val().split(',').filter(Boolean);
    let user_invite_emails = '';
    let list_invite_member_of_partner = '';
    $('.pics-table').find('.pick-pics').each(function( _index, ele ) {
      if($(ele).is(":checked")) {
        if($(ele).attr("name").includes("email")) {
          user_invite_emails += `,${$(ele).val()}|${$(ele).attr("data-type")}`
        } else if($(ele).attr("name").includes("partners")) {
          list_invite_member_of_partner += `,${$(ele).val()}|${$(ele).attr("data-type")}|${$(ele).attr("data-company-id")}|${$(ele).attr("data-name")}`
        } else {
          user_invite_ids.push($(ele).val())
        }
      }
    });

    $("#personInChargeOfObject").find('.list-user-invite-task').val(user_invite_ids);
    $("#personInChargeOfObject").find('.list-user-invite-delete').val(user_delete_ids);
    $("#personInChargeOfObject").find('.list-user-invite-by-email').val(user_invite_emails);
    $("#personInChargeOfObject").find('.list-invite-member-of-partner').val(list_invite_member_of_partner);

    $('#personInChargeOfObject').addClass('d-none')
    $("#personInChargeOfObject").modal('hide')
    $('#assignAkairePopup').modal('show')
    $('#assignAkairePopup').find('.number-user-invite-wrapper').removeClass('d-none');
    $('#assignAkairePopup').find('.number-user-invite-wrapper-dashed').removeClass('d-none');
    $('#assignAkairePopup').find('.number-user-invite').text(`${countUserInvite + countUserInviteNew - 1}名`);
    $('.btn-submit-assign-akaire').removeClass('d-none');
    $('.button-assign-member-wrapper').addClass('d-none');
  }

  addUserInvite(element, isAkapon) {
    const types = { owners: '自社', suppliers: '仕入先', clients: '販売先', collaborators: '外部' }
    const inviteUser = $('#js-select_users_invites').val();
    const inviteLists = $('#inviteLists');
    let listUserInvite = JSON.parse(inviteLists.find('.list-user-invite-task').val())
    const userName = $('#js-select_users_invites option:selected').text()
    const companyId = $('#js_select_company_invites_task :selected').val();
    const companyName = $(element).parent().find("#js_select_company_invites_task option:selected").text()
    const actionOnclick = `Task.deleteUserInvite(this)`
    const idAddUserInvite = $('#idAddUserInvite').val()

    if(inviteUser){
      var elementAdd = `<div class="tr d-flex">
                <div class="td t_invite cursor-pointer" onclick="TaskPic.handleCheckAction(this)">
                  <input type="checkbox" name="pic" id="pic" value="${inviteUser}" class="pick-pics d-none" checked>
                  <div class="check-view check-red"></div>
                </div>
                <div class="td d-flex t_name">
                  <span id="profileImage" class="avatar-member mr-1">
                    ${userName[0]}
                  </span>
                  <p>${userName}</p>
                </div>
              </div>`

      if($("#personInChargeOfObject").find(`input[value="${inviteUser}"]`).length) {
        $("#personInChargeOfObject").find(`input[value="${inviteUser}"]`).parent().click()
      } else {
        $("#personInChargeOfObject").find(".pics-table").append(elementAdd)
      }
      $("#personInChargeOfObject").attr('data-is-change', 'true')

      $("#personInChargeOfObject").attr('data-is-show', 'true')
      $("#personInChargeOfObject").modal("show")
      $("#addPersonInChargeOfObject").modal("hide")
      inviteLists.find('.invite_lists_inner').append(`<span class="invite_name" data-flag="new_permission_task" data-companyid="${companyId}" data-inviteid="${inviteUser}" onclick="${actionOnclick}">${userName}</span>`);
      const elementAdd_tmp = `<li class="dropdown-item" onclick="${actionOnclick}" data-flag="new_permission_task" data-companyid="${companyId}" data-inviteid="${inviteUser}"><span>${userName}</span><i data-feather="x-square" class="invite_delete"></i></li>`;
      inviteLists.find('.view_box_lists').append(elementAdd_tmp);
      listUserInvite.push(inviteUser)
      inviteLists.find('.list-user-invite-task').val(`[${listUserInvite}]`)
      $('#js-select_users_invites').find(`option[value="${inviteUser}"]`).remove();

      if(idAddUserInvite.length > 0){
        $('#idAddUserInvite').val(`${idAddUserInvite},${inviteUser}`)
      }else{
        $('#idAddUserInvite').val(inviteUser)
      }

      $('#invite-table-notice-text').empty();
    }
  }

  validateEmailBeforeInvite(popup_id, task_id, project_id) {
    let isSubmit = true
    let email = $(popup_id).find(".add_new_email_permission").val();
    let type = $(popup_id).find("#add_new_email_permission_type").val();
    let name = $(popup_id).find("#permission_name").val();
    if(email == "") {
      isSubmit = false;
      $(popup_id).find(".invite_email_error").html("空白にはできません。")
    } else {
      if(/^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i.test(email)) {
        $(popup_id).find(".invite_email_error").html("")
      } else {
        isSubmit = false;
      $(popup_id).find(".invite_email_error").html(I18n.t('admin.attributes.email.invalid'))
      }
    }

    if($(popup_id).find("#add_new_email_permission_type")) {
      if(type == "") {
        isSubmit = false;
        $(popup_id).find(".invite_type_error").html("空白にはできません。")
      } else {
        $(popup_id).find(".invite_type_error").html("")
      }
    }

    if($(popup_id).find("#permission_name").length > 0) {
      if (name.length > 0 && Shared.checkValidationUserName(name)) {
        Popup.alert('「ご担当者名」に利用できない文字があります。<br>ご担当者名を変更してください。')
        isSubmit = false;
      }
    }

    if(isSubmit) {
      $('.preloader').fadeIn();
      $(popup_id).attr('data-is-show-list-member', 'false');
      if(popup_id == '#inviteByEmail') {
        const url = Routes.owner_check_pic_to_task_by_email_path(project_id, task_id)
        const data = {
          'hard_submit': false,
          'permission': {
            'email': email,
            'type': type,
            'name': name
          }
        }
        Shared.callAjax(url, data, 'script', 'post').done()
      } else {
        const url = Routes.owner_check_partner_by_email_path(project_id, task_id)
        const data = {
          'permission_type': $(popup_id).find('#permission_type').val(),
          'company_id': $(popup_id).find('#company_id').val(),
          'permission': {
            'email': email,
            'name': name
          }
        }
        Shared.callAjax(url, data, 'script', 'post').done()
      }
    }
  }

  openSettingAuthorityModal(resetValues = false, fromAuthority = false) {
    if (resetValues) {
      if ($('#js_select_company_type_task').length > 0) {
        $('#js_select_company_type_task').val('');
        $('#js_select_company_invites_task').empty();
        $('#button_add_new_by_email').addClass('d-none')
      } else {
        $('#js_select_company_invites_task').val('');
      }
      $('.modal_add_member_name #js-select_users_invites').empty();
      $('#add_new_email_permission').val('');
      $('#add_new_email_permission_type').val('')
    }
    Shared.appendSelect2('#addPermissionProjectAuthor', '#js_select_company_invites_task', 'アカウント名を選択してください', 'アカウント名を検索', null, InviteUserShare.removeCompanyPrefixSuffix)
    Shared.appendSelect2('#addPermissionProjectAuthor', '#js_select_company_type_task', '取引種類を選択してください', '', InviteUserShare.customOptionCompanyType, InviteUserShare.removeCompanyPrefixSuffix)
    Shared.appendSelect2('#addPermissionProjectAuthor', '#js-select_users_invites', 'メンバー名を選択してください', 'メンバー名を検索', null)
    $('#addPermissionProjectAuthor').find('#js_select_company_invites_task')
      .val($('#addPermissionProjectAuthor').find('#js_select_company_invites_task option[data-type="owners"]').val())
      .trigger('change')
    Visiable.hide('#popupInviteMember')
    $('.modal-backdrop').remove();
    $("#addPermissionProjectAuthor").modal("show")
    if($('#current_company_id').length > 0) {
      this.getUserWithCompany('#current_company_id');
      $('#button_add_new_member').removeClass('d-none')
    } else {
      $('#button_add_member_of_partner').addClass('d-none')
    }

    if (fromAuthority) {
      $('.back-link-invite-wrapper').addClass('d-none')
    }
  }

  getUserWithCompany(ele) {
    let project_id = $('#projectId').val();
    let company_id = $(ele).val();
    const company_type = InviteUserShare.getCompanyType();
    InviteUserShare.updateCompanyTypeText(company_type)
    const disableValues = $(ele).data('participant-ids').toString().split(',').map(Number);
    const unSubmitValues = []

    $('.flex-table-authority #member_id').not('.invite_add_block #member_id').map(function () {
      const v = Number(this.value);
      if (!Number.isNaN(v)) {
        unSubmitValues.push(v);
      }
    })

    $('#inviteExistUserByEmail').find('#permission_type').val(company_type.slice(0, -1))
    if(company_type == 'owners') {
      $('#button_add_member_of_partner').addClass('d-none')
      $('#button_add_new_member').removeClass('d-none')
    } else {
      $('#button_add_member_of_partner').removeClass('d-none')
      $('#button_add_new_member').addClass('d-none')
    }
    if (company_id === 'invite_company') {
      $(ele).closest('#select_company_by_type').find('.btn.btn-mint').trigger('click');
      return;
    }
    $('#inviteExistUserByEmail').find('#company_id').val(company_id)
    const url = Routes.owner_list_user_not_user_permission_path(project_id);
    const data = {
      'company_id': company_id,
      'company_type': company_type
    };
    Project._handleFetchData(url, data, 'user', disableValues, unSubmitValues).then(() => {
      InviteUserShare.disableInvitedUserOptions('#js-select_users_invites')
    });
  }

  submitAssign(ele) {
    var isSubmit = true;
    const form = $('#animation-assign-form');
    const animationType = form.find('#animation_type').val()
    const isMaxVideoYouTube = $(ele).attr('is_max_number_youtube')
    if (animationType === 'youtube' && isMaxVideoYouTube === 'true' && $('.select-page-akaire').val() == 'new') {
      $('#assignAkairePopup').modal('hide')
      $('#errorModalForMaxYoutube').modal('show');
      isSubmit = false;
      return
    }
    if (
      animationType === 'image' &&
      form.find('#animation_type').attr('is-capture-url') == 'true' &&
      form.find('.select-page-akaire option:selected').attr('is-use-page-login') == 'false' &&
      $(ele).attr('is_max_page_login_number') === 'true'
    ) {
      $("#overPageLoginURLModal").modal('show');
      $('#assignAkairePopup').modal('hide')
      isSubmit = false;
      return
    }
    if($('.select-project-akaire').val() == 'new' && $('.select-project-akaire').attr('data-can-create-project') == 'false') {
      $('#assignAkairePopup').modal('hide')
      $('#errorModalForProjectAssign').modal('show')
      isSubmit = false
    }

    if($('#select-file-akaire-value').val() == 'cannot-new' || $('.select-file-akaire').val() == 'cannot-new') {
      Popup.confirm('データを保管できるファイル数が不足しています。', {
        cancelBtn: 'false',
        confirmText: 'プランを変更する',
        success: () => { window.open(Routes.owner_total_info_path()) },
        cancel: () => {},
        kind: 'akaire'
      })
      isSubmit = false
    }

    if(isSubmit) {
      $(ele).attr('disabled', true)
      $('#animation-assign-form').submit()
    }
  }

  autoSelectProjectDefault(element) {
    var select_default = $('#assignAkairePopup').find('.select-project-akaire').attr('data-select-default')
    const animation_id = $(element).attr('data-animation-id');
    const createFromProjectID = $(element).attr('data-from-project-id');
    const createFromProjectName = $(element).attr('data-from-project-name');
    const isShowTask = $(element).attr('data-is-show-task');
    const fileName = $(element).attr('data-file-name');
    const createFromTaskID = $(element).attr('data-from-task-id');
    const createFromTaskName = $(element).attr('data-from-task-name');
    const createFromWorkID = $(element).attr('data-from-work-id');
    const createFromAkaireFileID = $(element).attr('data-from-akaire-file-id');
    const createFromPageID = $(element).attr('data-from-page-id');
    const withNewTask = $(element).attr('data-with-new-task');
    $('#assignAkairePopup').find('.select-project-akaire option').toArray().forEach(element => {
      $(element).text($(element).text().replace('【作成元】', ''))
    });
    $('#assignAkairePopup').find('.display-from-project-name').text(createFromProjectName)
    $('#assignAkairePopup').find('.display-from-task-name').text(createFromTaskName)
    $('#assignAkairePopup').find('.display-file-name').text(fileName)
    $('#assignAkairePopup').find('#saved-project-id').val(createFromProjectID)
    $('#assignAkairePopup').find('#saved-task-id').val(createFromTaskID)
    $('#assignAkairePopup').find('#is-show-task').val(isShowTask)
    $('#modalEditSavedProjectName').find('#edit-saved-project-id').val(createFromProjectID)
    $('#modalEditSavedProjectName').find('#projectEditName').val(createFromProjectName)
    $('#modalEditSavedTaskName').find('#edit-saved-task-id').val(createFromTaskID)
    $('#modalEditSavedTaskName').find('#taskEditName').val(createFromTaskName)
    if (!!createFromTaskID) {
      $('#assignAkairePopup').find('.setting-saved-task-wrapper').removeClass('d-none');
      $('#assignAkairePopup').find('.task-setting-wrapper').addClass('d-none');
      $('#assignAkairePopup').find('.setting-saved-task-wrapper-dashed').removeClass('d-none');
    }
    $('#assignAkairePopup').find('.select-project-akaire').attr('data-from-project-id', createFromProjectID)
    $('#assignAkairePopup').find(`.select-task-akaire`).attr('data-from-task-id', createFromTaskID)
    $('#assignAkairePopup').find(`.select-ticket-akaire`).attr('data-from-work-id', createFromWorkID)
    $('#assignAkairePopup').find(`.select-file-akaire`).attr('data-from-file-id', createFromAkaireFileID)
    $('#assignAkairePopup').find(`.select-page-akaire`).attr('data-from-page-id', createFromPageID)
    $('#assignAkairePopup').find('.select-project-akaire').val(select_default).trigger('change')
    const projectId = $('#assignAkairePopup').find('#saved-project-id').val();
    const taskId = $('#assignAkairePopup').find('#saved-task-id').val();
    const url = taskId ? Routes.get_list_participants_akaire_feature_akaires_path() : Routes.project_participants_akaire_feature_akaires_path()
    if(projectId) {
      Shared.callAjax(url, {project_id: projectId, animation_id: animation_id, saved_task_id: taskId}, 'script', 'GET').done(() => {})
      $('#assignAkairePopup').find('.number-user-invite-wrapper').addClass('d-none');
      $('#assignAkairePopup').find('.number-user-invite-wrapper-dashed').addClass('d-none');
    }
    $('.btn-submit-assign-akaire').addClass('d-none');
    $('.button-assign-member-wrapper').removeClass('d-none');
    this.checkBlankProject(createFromProjectID, withNewTask)
  }

  checkBlankProject(createFromProjectID, withNewTask) {
    if($('#assignAkairePopup').attr('data-project-blank') == 'true') {
      $('#noticeWithFirstProject').modal('show')
    } else {
      if(!createFromProjectID) {
        $('#assignAkairePopup').find('.number-user-invite-wrapper').addClass('d-none');
        $('#assignAkairePopup').find('.number-user-invite-wrapper-dashed').addClass('d-none');
        this.showModalSelectSavedProject()
      } else {
        if(withNewTask && withNewTask.toString() == 'true') {
          this.createNewSavedTask()
        } else {
          $('#assignAkairePopup').modal('show')
        }
      }
    }
  }

  confirmDeleteAnimation() {
    Popup.confirm('一時保管データを削除します。<br> よろしいですか？', {
      cancelBtn: 'false',
      confirmText: 'OK',
      success: () => {
        $('.btn-delete-animation-hidden')[0].click()
      },
      cancel: () => {},
      kind: 'akaire'
    })
  }

  createNewSavedProject() {
    const animationId = $('#assignAkairePopup').find('#animation_id').val()
    if (!animationId) {
      Popup.alert('ファイルが選択されていません。')
      return
    }
    $('#createSavedProjectModal').find('#animation-id').val(animationId)
    $('#createSavedProjectModal').modal('show')
    $('#selectSavedProjectModal').modal('hide')
  }

  createNewSavedTask() {
    const animationId = $('#assignAkairePopup').find('#animation_id').val()
    const savedProjectId = $('#assignAkairePopup').find('#saved-project-id').val()
    if (!animationId) {
      Popup.alert('ファイルが選択されていません。')
      return
    }
    const self = this;
    $('#createSavedTaskModal').find('#animation-id').val(animationId)
    $('#createSavedTaskModal').find('#saved-project-id').val(savedProjectId)
    $('#createSavedTaskModal').find('#taskName').val('')
    $('#createSavedTaskModal').modal('show')
    $('#selectSavedTaskModal').modal('hide')
    $('#createSavedTaskModal').data('skipBackToSelect', false)
    $('#createSavedTaskModal').one('hidden.bs.modal', function() {
      if (!$(this).data('skipBackToSelect')) {
        self.showModalSelectSavedTask()
      }
    })
  }

  removeDisabledBtnInvite(element) {
    const modalEle = $(element).parents('div.modal-body');
    const userSelect = modalEle.find('#js-select_users_invites').val()
    if (userSelect && userSelect !== '') {
      $(element).parents('div.modal-body').find('#inviteAdd').removeClass('disabled');
    } else {
      $(element).parents('div.modal-body').find('#inviteAdd').addClass('disabled');
    }
  }

  _toggleBtnUpgradePlan(isProjectOwner) {
    $("#overPageLoginURLModal").find('div#btnForProjectOwnerModalOverPageLogin').toggleClass('d-none', !isProjectOwner)
    $("#errorModalForMaxYoutube").find('div#btnForProjectOwnerModalOverPageLogin').toggleClass('d-none', !isProjectOwner)
  }

  _setInfoOfModalWarningLimit() {
    $("span.project_owner_plan_name").text($('input#inputCurrentPlanName').val())
    $("span.project_owner_plan_limit_youtube").text($('input#inputCurrentPlanLimitYoutube').val())
    $("span.project_owner_plan_limit_login_page").text($('input#inputCurrentPlanLimitPageLogin').val())
  }

  createSavedTask() {
    $('#createSavedTaskModal').data('skipBackToSelect', true)
    $('#createSavedTaskModal').modal('hide')
    $('#assignAkairePopup').modal('show')
  }
}
